import { render } from "./ProfileDialog.vue?vue&type=template&id=66db0d22&scoped=true"
import script from "./ProfileDialog.vue?vue&type=script&lang=js"
export * from "./ProfileDialog.vue?vue&type=script&lang=js"

import "./ProfileDialog.vue?vue&type=style&index=0&id=66db0d22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66db0d22"]])

export default __exports__